import urljoin from 'url-join';
import ky from './kyInstance';
import { BASE_PATH, EVENTUS_EVENTS_BASE_PATH, withAuthorizationHeader } from '../index';

export const addToNewsletter = async (body) => {
  return ky.post(urljoin(BASE_PATH, 'newsletter', 'add-member'), {
    headers: withAuthorizationHeader(),
    body,
  });
};

export const connectAzure = async () => {
  return ky.get(urljoin(BASE_PATH, 'auth', 'connect', 'azure'), {
    headers: withAuthorizationHeader(),
  });
};

export const helpCenterBooklets = async (openType) => {
  return ky.get(urljoin(BASE_PATH, 'pdf-booklets', openType), {
    headers: withAuthorizationHeader(),
  });
};

export const ssoIpmaShopUri = async () => {
  return ky.get(urljoin(BASE_PATH, 'sso', 'ipma-shop'), {
    headers: withAuthorizationHeader(),
  });
};

export const ssoMyCoursesUri = async () => {
  return ky.get(urljoin(BASE_PATH, 'sso', 'my-courses'), {
    headers: withAuthorizationHeader(),
  });
};

export const getEventusEvent = async (eventId) => {
  return ky.get(urljoin(EVENTUS_EVENTS_BASE_PATH, 'event', 'find-by-id', eventId));
};
